export function shareThis() {
  /* https://platform.sharethis.com/settings */
  const hostName = window.location.hostname;
  let shareThisProperty = "5ae04564f6d9bd001192a928";

  if (hostName === "therealyouapp.com") {
    shareThisProperty = "5aaa52bcaa14db0013c304b1";
  } else if (hostName === "therealyouapp.nl") {
    shareThisProperty = "5aaa7604aa14db0013c304d9";
  } else if (hostName === "wc-try.firebaseapp.com") {
    shareThisProperty = "5aaa76151323eb0013e8637c";
  } else {
    /* localhost */
  }

  const scriptSrc = `//platform-api.sharethis.com/js/sharethis.js#property=${shareThisProperty}&product=custom-share-buttons`;

  const shareScript = document.createElement("script");
  shareScript.setAttribute("src", scriptSrc);
  document.head.appendChild(shareScript);
}

export const gRecaptcha = {
  sitekey: "6LcQZn8UAAAAANamphKAVeojWhd2ZtNTyy4KGmI8"
};

export const cloudinaryConfig = {
  cloudName: "csteeg" // petticode
};

export const firebase = {
  apiKey: "AIzaSyAZ-dcFYf_KKxLOEHIcqOdvpDv0ExLMNSQ",
  authDomain: "wc-try.firebaseapp.com",
  databaseURL: "https://wc-try.firebaseio.com",
  projectId: "wc-try",
  storageBucket: "wc-try.appspot.com",
  messagingSenderId: "586922577360",
  cloudFunctionsUrl: "https://europe-west1-wc-try.cloudfunctions.net"
};

export const gAnalytics = {
  nl: {
    id: "UA-131156420-1",
    name: "TheRealYouApp.nl"
  },
  com: {
    id: "UA-131156420-2",
    name: "TheRealYouApp.nl"
  }
};
